import type { Nullable } from '../typescript/nullable';
import type { OmitKeys } from '../typescript/omit-keys.type';
import type { Require } from '../typescript/require';
import { CustomPropertyIconEnum } from './custom-property-icon.enum';
import type { CustomPropertyKeys } from './custom-property-id-keys';
import { CustomPropertyDatatype, CustomPropertyType } from './custom-property-type.enum';
import type { AnyCustomPropertyValue } from './custom-property-value.interface';

//Custom Property Interface is the custom property definition itself, the one found in the user

//#region CP
export interface CustomPropertyInterface {
	id: string;
	key: Nullable<CustomPropertyKeys>;
	name: string;
	description: Nullable<string>;
	datatype: CustomPropertyDatatype;
	type: CustomPropertyType;
	options: Nullable<CustomPropertySelectionOption[]>;
	isAiPopulated: boolean;
	permissions: CustomPropertyPermissions[];
	icon: Nullable<CustomPropertyIconEnum>;
}
export interface CustomPropertySelectionOption {
	value: string;
	color?: string; // Hex color code
}
export type CustomPropertyCreateInterface = OmitKeys<
	Require<Partial<CustomPropertyInterface>, 'name' | 'type'>,
	'datatype' | 'id' | 'key' | 'permissions'
>;
export type CustomPropertyUpdateInterface = OmitKeys<
	Partial<CustomPropertyInterface>,
	'datatype' | 'id' | 'key' | 'permissions' | 'type' | 'options'
>;

export type CustomPropertyUpdateNameInterface = Pick<CustomPropertyInterface, 'name'>;

export type CustomPropertyUpdateOptionsInterface = Pick<CustomPropertyInterface, 'options'>;

export enum CustomPropertyPermissions {
	/**
	 * The user can remove the property completely
	 * from the node (remember that the name can
	 * always be changed)
	 */
	REMOVE_FROM_USER = 'REMOVE_FROM_USER',
	/**
	 * The user can edit the value of the property as
	 * well as remove the property from the node
	 */
	ADD_EDIT_REMOVE_FROM_NODE = 'ADD_EDIT_REMOVE_FROM_NODE',
}

// #endregion

//#region Misc
export interface PropertyModified {
	//@Frontend, we dont use this in backend, maybe move to frontend types?
	value: AnyCustomPropertyValue;
	options?: CustomPropertySelectionOption[];
}

//#endregion
